<template>
  <ul class="nav side-nav-bar">
    <li class="nav-item">
      <span class="nav-link d-none d-lg-block">
        <p
          class="d-inline-block mr-3 mr-lg-0 mb-3 font-weight-normal text-uppercase"
        >
          {{ $resourceString["account.SideBar.Header"] }}
        </p>
      </span>
      <a
        class="collapse-toggle collapsed nav-link d-lg-none"
        data-toggle="collapse"
        role="button"
        href="#navbar-acc-sidebar"
        aria-expanded="false"
        aria-controls="navbar-acc-sidebar"
      >
        <p
          class="d-inline-block mr-3 mr-lg-0 mb-3 font-weight-normal text-uppercase"
        >
          {{ $resourceString["account.SideBar.Header"] }}
          <span class="png-icon png-icon-icons-glyph--k-mobile-menu "> </span>
        </p>
      </a>
      <hr class="border-accent-gray-alt d-none d-lg-block" />
      <div class="collapse d-lg-block" id="navbar-acc-sidebar">
        <ul class="nav row">
          <li
            class="nav-item mb-2 col-12"
            v-for="link in links"
            :key="link.href"

          >
            <a
              :href="link.href"
              class="nav-link side-nav-item text-uppercase"
              :class="
                link.text == selectedTab ? 'selected-page font-weight-bold' : ''
              "
            >
              {{ link.text }}
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["enableProjectFeature"],
  data() {
    return {
      links: [
        {
          href: "/Account",
          text: this.$resourceString["account.SideBar.UserSetting.Title"]
        },
        {
          href: "/Account/OrderHistory",
          text: this.$resourceString["account.SideBar.OrderHistory.Title"]
        },
        {
          href: "/Account/MyTrays?tab=active",
          text: this.$resourceString["account.SideBar.MyTrays.Title"]
        },
        {
          href: "/Account/AccountSupport",
          text: this.$resourceString["account.SideBar.AccountSupport.Title"]
        }
      ],
      tmpEnableProjectFeature: this.enableProjectFeature ? this.enableProjectFeature : document.getElementById('EnableProjectFeature').value == "True"
    };
  },
  computed: {
    ...mapGetters({
      selectedTab: "myTray/getselectedSideNav"
    })
  },
  methods: {
    ...mapActions({
      updateSelectedSideNav: "myTray/updateSelectedSideNav"
    }),
    handleSideNav(selectedNav){
      this.updateSelectedSideNav(selectedNav)
    }
  },
  mounted() {
    const url = new URL(window.location.href);

    const parts = url.href?.split("/");
    let lastPart = parts[parts.length - 1];
    let activeSideNav = this.links.find(item=>{
    const lastIndexOfSlash =item.href.lastIndexOf('/');
    if (lastIndexOfSlash !== -1) {
      let extractedPart = item.href.slice(lastIndexOfSlash + 1);
      return  extractedPart.toLowerCase() === lastPart.toLowerCase()
    }

    })
    let sideNavName = window.location.href.toLowerCase().includes("myprojects") ? this.$resourceString["myProject.MyProjects.Title"] : this.$resourceString["account.SideBar.MyTrays.Title"];
        if (activeSideNav) {
          sideNavName = activeSideNav.text ;
        }
    this.handleSideNav(sideNavName)
  },
  created(){
    if(this.tmpEnableProjectFeature)
    {
      this.links = [...this.links, {
          href: "/Account/MyProjects?tab=active",
          text: this.$resourceString["myProject.MyProjects.Title"]
        }
      ]
    }
  }
};

</script>
